import { styled } from 'styled-components';

import { themed } from 'styled/helpers';

const StyledIcon = styled.svg`
  --icon-color-accent: ${themed('color/gray/0')};
  --icon-color-main: currentColor;
`;

export default StyledIcon;
